import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { heroSocials, heroStats } from '../data/heroStats';
import { INTRO, lineRise } from '../utils/reveal';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * Bottom row of the hero, just above the showreel: proof point (left) and social links (right).
 * Each item is its own clip mask (for the rise-in) and is marked `data-drone-push`, so a hypnotised
 * Pixel can knock it about.
 */
export function StatsRow() {
  const reduce = useReducedMotion();
  const mobile = useIsMobile();
  return (
    // Mobile: centred stack with a little more air between tagline and socials; desktop: one row
    <div className="grid grid-cols-1 justify-items-center gap-4 px-3 text-center text-base md:text-[clamp(0.875rem,calc(1.05*var(--vw)),1.25rem)] font-bold uppercase leading-tight tracking-[0.01em] text-black md:grid-cols-2 md:justify-items-start md:gap-1 md:px-[calc(1.6*var(--vw))] md:text-left" data-id="element-295" data-mp="3s15xuqquvkmx">
      <ul aria-label="Results" className="contents" data-id="element-296" data-mp="34b1wkq153wz3">
        {heroStats.map((stat, i) =>
        // Each item rises up out of its own line on page load, left → center → right
        <li key={stat} data-drone-push
        // Mobile: the tagline sits under the logo instead (HeroSection), so only the socials stay here
        className={`hidden w-fit overflow-hidden pb-[0.12em] md:block ${i === 1 ? 'md:justify-self-center' : ''}`} data-id="element-297" data-mp="3c449ykhsmdui" data-mpi={i}>
            <motion.span className="block" {...lineRise(INTRO.stats + i * INTRO.stat, reduce)} data-id="element-298" data-mp="2xb0r89sgtu27">
              {stat}
            </motion.span>
          </li>)}
      </ul>

      {/* Phones: the socials sit in the top-right corner instead (HeroSection) */}
      <nav aria-label="Social" data-drone-push className="hidden w-fit overflow-hidden pb-[0.12em] md:block md:justify-self-end" data-id="element-299" data-mp="2jedqrx1b0lrj">
        {/* Phones: first in the bottom-up intro */}
        <motion.p key={mobile ? 'm' : 'd'} className="block" {...mobile ? {} : lineRise(INTRO.stats + heroStats.length * INTRO.stat, reduce)} data-id="element-300" data-mp="hlpobpwhi2ct">
          {heroSocials.map((link, i) => <React.Fragment key={link.label} data-id="element-301" data-mp="15ivmodqaa68z" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="px-[0.6em] text-neutral-400" data-id="element-302" data-mp="rqyzmo3h2mjg">
                  /
                </span>}
              <a href={link.href} target="_blank" rel="noopener noreferrer" className="pointer-events-auto rounded-sm transition-opacity duration-200 ease-out hover:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black" data-id="element-303" data-mp="wmwfyueqjsw8">
                {link.label}
              </a>
            </React.Fragment>)}
        </motion.p>
      </nav>
    </div>
  );
}